import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { IC_STAR, IC_STAR_FILLED, IC_STAR_FILLED_GREY, IC_STAR_YELLOW_BORDER } from '../../Assets/images';
import { StartRatingStyled } from './StarRatingStyled';

function StarBox({ count, value, inActiveImage, activeImage, size = 30, onChange }) {
  const stars = Array.from({ length: count }, () => '');

  const handleChange = (value) => {
    onChange && onChange(value + 1);
  };
  return (
    <ul>
      {stars.map((s, i) => {
        let imgStar = inActiveImage;
        if (i < value) {
          imgStar = activeImage;
        }
        return (
          <li key={i} onClick={() => handleChange(i)} data-testid={`starId${i}`}>
            <Image src={imgStar} width={size} height={size} alt="" />
          </li>
        );
      })}
    </ul>
  );
}

const StarRating = ({ customClass, size, rating, handleChange, validation, starBorderYellow }) => (
  <StartRatingStyled className={customClass}>
    <StarBox
      count="5"
      size={size || 30}
      value={rating}
      starBorderYellow
      inActiveImage={starBorderYellow ? IC_STAR_YELLOW_BORDER.src : IC_STAR_FILLED_GREY.src}
      activeImage={IC_STAR_FILLED.src}
      onChange={handleChange}
      validation={validation}
    />
    {validation && <div className="error">Please rate your experience</div>}
  </StartRatingStyled>
);

StarRating.defaultProps = {
  rating: 0,
  handleChange: () => {},
  validation: false,
  customClass: '',
  size: '',
  starBorderYellow: false,
};

StarRating.propTypes = {
  rating: PropTypes.number,
  handleChange: PropTypes.func,
  validation: PropTypes.bool,
  customClass: PropTypes.string,
  size: PropTypes.string,
  starBorderYellow: PropTypes.bool,
};
StarBox.propTypes = {
  count: PropTypes.string,
  value: PropTypes.string,
  inActiveImage: PropTypes.string,
  activeImage: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
};
StarBox.defaultProps = {
  count: 5,
  value: 0,
  inActiveImage: IC_STAR,
  activeImage: IC_STAR_FILLED,
  size: 30,
  customClass: '',
  onChange: () => {},
};
export default StarRating;
